import { render, staticRenderFns } from "./TotalSystem.vue?vue&type=template&id=55d471bf&scoped=true"
import script from "./TotalSystem.ts?vue&type=script&lang=ts&external"
export * from "./TotalSystem.ts?vue&type=script&lang=ts&external"
import style0 from "./TotalSystem.vue?vue&type=style&index=0&id=55d471bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d471bf",
  null
  
)

export default component.exports